import BaseClient from './BaseClient';

class ExternalListsClient extends BaseClient {
    getExternalLists(teamId, params) {
        const url = `/api/v3/teams/${teamId}/external-contact-lists`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsCount(teamId, params) {
        const url = `/api/v3/teams/${teamId}/external-contact-lists/count`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsContactCount(teamId, params) {
        const url = `/api/v3/teams/${teamId}/external-contact-lists/contact-counts`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsAttributes(teamId, params) {
        const url = `/api/v3/teams/${teamId}/external-contact-lists/attributes`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}

export default new ExternalListsClient();
